import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Row } from 'reactstrap';

//Components
import TextField from '../../../../components/TextField';
import ModalCustomized from '../../../../components/Modal/Modal';

//Helpers
import mascaras from '../../../../helpers/mascaras';
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../../helpers/message';
import { getSessionCookie } from '../../../../helpers/cookies';

//Context
import { useAuth } from '../../../../context/auth';

//API
import cep_api from '../../../../api/cep_api';
import confirmacaoInfrator_api from '../../../../api/confirmacaoInfrator_api';


function initialStateInfrator(secretaria_Id, UsuarioAtualizacao_Id, fiscalizacao_Id) {
    return {
        nomeRazao: "",
        email: "",
        telefone: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        documentoIdentificacao: "",
        secretaria_Id: secretaria_Id,
        usuarioAtualizacao_Id: UsuarioAtualizacao_Id,
        fiscalizacao_Id: fiscalizacao_Id
    }
};

function IndicarInfrator({ indicarInfrator, setIndicarInfrator }) {
    const session = getSessionCookie();

    //State para Criar / Editar
    const [infrator, setInfrator] = useState(initialStateInfrator(session.secretaria_Id, session.id, indicarInfrator.id));

    //State para visibidade do modal
    const [visibilidadeModal, setVisibilidadeModal] = useState(true);

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    const { setLoading } = useAuth();


    const toggleModal = () => {
        setVisibilidadeModal(false);
        setIndicarInfrator(null);
    }

    useEffect(() => {
        if (indicarInfrator && indicarInfrator.infrator) {
            setInfrator(indicarInfrator.infrator)
        }
    }, [])

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "nomeRazao", required: true }),
        objCampo({ name: "email", required: true }),
        objCampo({ name: "telefone", required: true }),
        objCampo({ name: "cep", required: true }),
        objCampo({ name: "logradouro", required: true }),
        objCampo({ name: "numero", required: true }),
        objCampo({ name: "bairro", required: true }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "uf", required: true }),
    ])


    //Função de onChange dos campos de cadastro
    const onChange = (e) => {
        const { name, value } = e.target;
        const _infracao = {
            ...infrator,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_infracao, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setInfrator(_infracao);
    }

    const onBlur = (e) => {
        if (e.target.value.length < 9) return;

        setLoading(false)
        cep_api.get(e.target.value)
            .then(response => {
                setInfrator({
                    ...infrator,
                    cep: response.data.cep,
                    logradouro: response.data.logradouro,
                    complemento: response.data.complemento,
                    bairro: response.data.bairro,
                    cidade: response.data.localidade,
                    uf: response.data.uf
                })
            })
            .catch(err => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
    }

    //Função para dar submit nos dados do documento
    const onSubmit = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(infrator, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _infrator = {...infrator}

        setLoading(true);
        confirmacaoInfrator_api.PostOrUpdateInfrator(_infrator)
            .then(response => {
                showMessage("Aviso", "Operação com sucesso", "success", () => {
                    setVisibilidadeModal(false);
                    setIndicarInfrator(null);
                });
            })
            .catch(err => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false))
    }

    return <>
        {visibilidadeModal &&
            <ModalCustomized
                title={"Indicar Infrator"}
                isOpen={visibilidadeModal}
                toggle={toggleModal}
                btnClose={toggleModal}
                btnActionColor="success"
            >
                <Row>
                    <Col md="12" lg="4">
                        <TextField
                            label="* Nome"
                            name={"nomeRazao"}
                            onChange={onChange}
                            value={infrator.nomeRazao}
                            maxLength={200}
                            invalid={!!errors.nomeRazao}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            label="* Documento identificação"
                            name={"documentoIdentificacao"}
                            onChange={onChange}
                            value={infrator.documentoIdentificacao}
                            maxLength={18}
                            invalid={!!errors.documentoIdentificacao}
                            mask={mascaras.cpfcnpjMask}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            label="* Email"
                            name={"email"}
                            onChange={onChange}
                            value={infrator.email}
                            maxLength={200}
                            invalid={!!errors.email}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            label="* Telefone"
                            name={"telefone"}
                            mask={mascaras.telefoneMask}
                            onChange={onChange}
                            value={infrator.telefone}
                            maxLength={14}
                            invalid={!!errors.telefone}
                        />
                    </Col>
                    <Col md="12" lg="3">
                        <TextField
                            label="* CEP"
                            name={"cep"}
                            mask={mascaras.cepMask}
                            onChange={onChange}
                            onBlur={onBlur}
                            value={infrator.cep}
                            maxLength={9}
                            invalid={!!errors.cep}
                        />
                    </Col>
                    <Col md="12" lg="3">
                        <TextField
                            label="* Cidade"
                            name={"cidade"}
                            onChange={onChange}
                            value={infrator.cidade}
                            maxLength={150}
                            invalid={!!errors.cidade}
                        />
                    </Col>
                    <Col md="12" lg="2">
                        <TextField
                            label="* UF"
                            name={"uf"}
                            onChange={onChange}
                            value={infrator.uf}
                            invalid={!!errors.uf}
                            maxLength={2}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            label="* Bairro"
                            name={"bairro"}
                            onChange={onChange}
                            value={infrator.bairro}
                            maxLength={150}
                            invalid={!!errors.bairro}
                        />
                    </Col>
                    <Col md="12" lg="6">
                        <TextField
                            label="* Logradouro"
                            name={"logradouro"}
                            onChange={onChange}
                            value={infrator.logradouro}
                            maxLength={150}
                            invalid={!!errors.logradouro}
                        />
                    </Col>
                    <Col md="12" lg="2">
                        <TextField
                            type={"text"}
                            label="* Numero"
                            name={"numero"}
                            mask={mascaras.numeroMask}
                            onChange={onChange}
                            value={infrator.numero}
                            maxLength={10}
                            invalid={!!errors.numero}
                        />
                    </Col>
                    <Col md="12" lg="12">
                        <TextField
                            label="Complemento"
                            name={"complemento"}
                            onChange={onChange}
                            value={infrator.complemento}
                            maxLength={30}
                        />
                    </Col>
                    <Col md="12" lg="12" className='d-flex align-items-center justify-content-center mt-3'>
                        <Button
                            className='px-4'
                            color={infrator.id ? 'warning text-white' : 'success'}
                            onClick={onSubmit}
                            disabled={indicarInfrator?.infrator?.documentoIdentificacao ?? false}
                        >
                            {infrator.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
                        </Button>
                    </Col>
                </Row>
            </ModalCustomized>
        }
    </>;
}

export default IndicarInfrator;